export default __webpack_public_path__ + "static/media/zapatos.4fb4c623.png";